import { LeafMultimediaBrightcove } from "./multimedia-brightcove.component.js";
customElements.define("leaf-multimedia-brightcove", LeafMultimediaBrightcove);
export {
  LeafMultimediaBrightcove
};
//# sourceMappingURL=multimedia-brightcove.js.map
